<template>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M12.2508 3.28107L9.15314 0.602C9.07695 0.536141 8.97984 0.5 8.87923 0.5H0.814102C0.582914 0.5 0.395508 0.687406 0.395508 0.918594V12.0814C0.395508 12.3126 0.582914 12.5 0.814102 12.5H11.9769C12.2081 12.5 12.3955 12.3126 12.3955 12.0814V3.59766C12.3955 3.47614 12.3426 3.36059 12.2508 3.28107ZM11.5583 11.6628H1.23272V1.33721H8.72337L11.5583 3.78912V11.6628Z"  class="icon-fill"/>
      <path d="M7.37207 0.917969V3.77845H4.02325V0.917969H3.18604V4.19704C3.18604 4.42825 3.37344 4.61563 3.60463 4.61563H7.79068C8.02189 4.61563 8.20928 4.42823 8.20928 4.19704V0.917969H7.37207Z"  class="icon-fill"/>
      <path d="M8.48828 7.40723H2.90688C2.67566 7.40723 2.48828 7.59461 2.48828 7.82582V12.0816H3.32549V8.24444H8.06969V12.0816H8.9069V7.82582C8.9069 7.59461 8.71949 7.40723 8.48828 7.40723Z"  class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12"  class="icon-fill" transform="translate(0.395508 0.5)"/>
      </clipPath>
    </defs>
  </svg>



</template>

<script>
export default {
  name: 'save'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}

</style>